import { Injectable } from "@angular/core";

/**
 * @deprecated Use `provideDynamicFavicon` from `@firm360/libs/util/browser` instead.
 */
// TODO: Replace this service with `provideDynamicFavicon` from the browser lib rather than modifying it.
@Injectable({ providedIn: "root" })
export class FaviconService {
    private readonly mobileFavicon: string = "assets/img/brand/favicon_sm.png";
    private readonly desktopFavicon: string =
        "assets/img/brand/favicon_full.png";

    init() {
        this.updateFavicon();
        window.addEventListener("resize", this.updateFavicon.bind(this));
    }

    private updateFavicon(): void {
        const isMobile = window.matchMedia("(max-width: 767px)").matches;
        const iconUrl = isMobile ? this.mobileFavicon : this.desktopFavicon;
        this.setFavicon(iconUrl);
    }

    private setFavicon(href: string): void {
        const existingLink = document.getElementById(
            "dynamic-favicon",
        ) as HTMLLinkElement;
        const url = new URL(href, window.location.origin);
        url.searchParams.set("v", Date.now().toString());

        if (existingLink) {
            existingLink.href = url.toString();
        } else {
            const link = document.createElement("link");
            link.id = "dynamic-favicon";
            link.rel = "icon";
            link.type = "image/png";
            link.href = url.toString();
            document.head.appendChild(link);
        }
    }
}
